import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../store/slices/authSlice';

function Navbar() {
  const { user, currentTenant } = useSelector((state) => state.auth);
  const { unreadCount } = useSelector((state) => state.notifications);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const getMarketPlaceName = () => {
    if (currentTenant?.paas?.name) return currentTenant.paas.name;
    if (currentTenant?.saas?.name) return currentTenant.saas.name;
    return 'MultiPaaS';
  };
  
  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };
  
  const getDashboardLink = () => {
    switch (user?.role) {
      case 'superadmin':
        return '/super-admin/dashboard';
      case 'admin':
        const tenant = JSON.parse(localStorage.getItem('tenantSession') || '{}');
        return tenant?.paasId ? `/paas-admin/${tenant.paasId}` : '/paas-admin';
      case 'saas-admin':
        const saasTenant = JSON.parse(localStorage.getItem('tenantSession') || '{}');
        return saasTenant?.saasId ? `/saas-admin/${saasTenant.saasId}` : '/saas-admin';
      case 'client-admin':
      case 'owner':
        const clientTenant = JSON.parse(localStorage.getItem('tenantSession') || '{}');
        return clientTenant?.tenantId ? `/client-admin/${clientTenant.tenantId}` : '/client-admin';
      default:
        return '/dashboard';
    }
  };

  const getDashboardLabel = () => {
    switch (user?.role) {
      case 'superadmin':
        return 'Super Admin';
      case 'admin':
        return 'PAAS Admin';
      case 'saas-admin':
        return 'SaaS Admin';
      case 'client-admin':
      case 'owner':
        return 'Client Admin';
      default:
        return 'Dashboard';
    }
  };
  
  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/dashboard">{getMarketPlaceName()}</Link>
      </div>
      <div className="navbar-menu">
        <Link to={getDashboardLink()}>
          {getDashboardLabel()}
        </Link>
        {(user?.role === 'superadmin' || user?.role === 'admin') && (
          <Link to="/admin">Admin Panel</Link>
        )}
        {(user?.role === 'user' || user?.role === 'moderator') && (
          <Link to="/content">Content</Link>
        )}
        <Link to="/notifications">
          Notifications
          {unreadCount > 0 && <span className="badge">{unreadCount}</span>}
        </Link>
        <Link to="/profile">Profile</Link>
        <button onClick={handleLogout} className="btn-logout">Logout</button>
      </div>
      <div className="navbar-user">
        <span>{user?.email}</span>
        <span className="role-badge">{user?.role}</span>
      </div>
    </nav>
  );
}

export default Navbar;